// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color[data-v-246ad34c]{fill:#b3caef}.color.active[data-v-246ad34c]{fill:#ffa000}.color-2[data-v-246ad34c]{fill:#c4d7f5}.color-2.active[data-v-246ad34c]{fill:#ffc107}.notif[data-v-246ad34c]{fill:#ebf3ff}.notif.active[data-v-246ad34c]{fill:#ff6400}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
